module.exports = __webpack_public_path__ + "7cf38faa39bfba1f5b14535f1af377fe.svg";